/**
 * Bundled English locale — registered via `i18n.addResourceBundle()` after init,
 * so the Phrase OTA backend remains active for the `translation` namespace.
 *
 * Use for UI infrastructure strings (pagination, calendar labels, generic statuses)
 * that must be available before Phrase loads and are not managed by the content team.
 *
 * To add a new namespace:
 *   1. Create `src/lib/i18n/locales/en/<namespace>.ts`
 *   2. Create the equivalent `src/lib/i18n/locales/de/<namespace>.ts`
 *   3. Export both from their respective `index.ts` barrels
 *   4. Update the namespace table in `docs/i18n.md`
 *
 * Do NOT add feature-specific or editorial strings here — those belong in Phrase.
 */
import table from './table';

const enLocale = { table } as const;

export default enLocale;
